import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { addFacebookMeta, updFacebookMeta } from "@/api/management/facebookData";
import { mapState } from "vuex";
import { serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        decrypt_key: ""
      },
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      rules: {
        game: [{
          required: true,
          message: this.$t('gameNotEmpty'),
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: this.$t('platformNotEmpty'),
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: this.$t('channelNotEmpty'),
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: this.$t('pkgNotEmpty'),
          trigger: "blur"
        }],
        decrypt_key: [{
          required: true,
          message: this.$t('decryptionKeyNotEmpty'),
          trigger: "blur"
        }]
      },
      ex_Val: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!data) {
                  _context.next = 9;
                  break;
                }

                _context.next = 4;
                return _this.gamechangeManage(data.game);

              case 4:
                _context.next = 6;
                return _this.platformchangeManage(data.platform);

              case 6:
                _context.next = 8;
                return _this.channelchangeManage(data.channel);

              case 8:
                _this.searchData = _objectSpread(_objectSpread(_objectSpread({}, _this.searchData), data), {}, {
                  decrypt_key: data.key
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm() {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        decrypt_key: ""
      };
      this.searchplatforms = [];
      this.searchchannels = [];
      this.searchpkgs = [];
      this.ex_Val = [];
      this.$refs.ruleForm.resetFields();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (vaild) {
        if (vaild) {
          var reqFn = _this2.searchData.id ? updFacebookMeta : addFacebookMeta;
          reqFn(_this2.searchData).then(function (res) {
            if (res.code == 200) {
              Message.success(_this2.$t('operationSuccess'));

              _this2.resetForm();

              _this2.$emit("change", false);
            }
          });
        }
      });
    }
  }
};